var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-button-container"},_vm._l((_vm.items),function(item,index){return _c('div',{key:index,staticClass:"image-button-wrapper"},[_c('img',{attrs:{"src":item.image,"alt":`Image ${index + 1}`}}),_c('button',{on:{"click":function($event){return _vm.handleButtonClick(item.link)}}},[_vm._v("Inscreva-se")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }